import React from "react";
/** Small chevron used inside pill buttons and popovers (16×16). */
export default function ChevronDownIcon({ className }) {
    return (<svg className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.1381 5.52876C13.3985 5.78911 13.3985 6.21112 13.1381 6.47147L8.47145 11.1381C8.2111 11.3985 7.78909 11.3985 7.52874 11.1381L2.86207 6.47147C2.60172 6.21112 2.60172 5.78911 2.86207 5.52876C3.12242 5.26841 3.54443 5.26841 3.80478 5.52876L8.00009 9.72407L12.1954 5.52876C12.4558 5.26841 12.8778 5.26841 13.1381 5.52876Z" fill="currentColor"/>
    </svg>);
}
